<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="flex flex-col border-b border-solid border-gray-200 py-5">
    <button
      class="flex cursor-pointer items-center justify-between text-left"
      :title="itemData.name"
      @click="handleToggle"
    >
      <div
        class="w-full pr-4 text-xl font-bold hover:text-blue-400 hover:underline"
      >
        {{ itemData.name }}
      </div>
      <div class="h-6 w-6 basis-6">
        <IconCaret
          :direction="isShow ? 'up' : 'down'"
          class="h-full w-full text-blue-400"
        />
      </div>
    </button>
    <div v-if="isShow" class="mt-4">
      <p
        class="text-sm leading-6 text-gray-600 tablet:text-base"
        v-html="provideSanitized(decode(itemData.description))"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
  import { decode } from 'entities';

  import type { IItem } from '@/components/Shared/Suite/TopicsFaq/index.vue';

  interface IProps {
    defaultShow: boolean;
    itemData: IItem;
  }

  const props = withDefaults(defineProps<IProps>(), {
    defaultShow: false,
    itemData: () => ({
      name: '',
      description: '',
    }),
  });

  const isShow = ref<boolean>(props.defaultShow);

  const handleToggle = (): void => {
    isShow.value = !isShow.value;
  };
</script>
